import { REGIONS } from '../data/site';
import { useSite } from '../data/SiteContext';

export default function About() {
  const { dests, tours, cruises, events, contact } = useSite();
  // Real numbers, computed from live data — no invented marketing stats.
  const stats = [
    { value: String(dests.length || '—'), label: 'Destinations' },
    { value: String(new Set(dests.map(d => d.country)).size || '—'), label: 'Countries' },
    { value: String((tours.length + cruises.length) || '—'), label: 'Tours & cruises' },
    { value: String(events.filter(e => e.isActive).length || '—'), label: 'Events & festivals' },
  ];
  return (
    <div style={{ maxWidth:1000, margin:'0 auto', padding:'40px 24px 72px' }}>
      <div className="kicker">About Us</div>
      <h1 className="page-h1" style={{ marginBottom:18 }}>Happiness without borders.</h1>
      <p style={{ fontSize:19, lineHeight:1.7, color:'#31474a', margin:'0 0 16px' }}>{contact.brand} started with one belief: a holiday should never be a gamble.</p>
      <p style={{ fontSize:16.5, lineHeight:1.75, color:'#5a726f', margin:'0 0 30px' }}>We plan every trip end to end — flights, stays, transfers and excursions — and we stay reachable while you travel. Whether it's a week in Punta Cana, a Nile cruise or a proposal on a private beach, the same small team handles it from first message to touchdown home.</p>
      <div className="card-cool" style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(150px,1fr))', gap:2, borderRadius:22, overflow:'hidden', marginBottom:30 }}>
        {stats.map(s => (
          <div key={s.label} style={{ padding:'26px 20px', textAlign:'center', borderRight:'1px solid #eaf6f2' }}>
            <div className="serif" style={{ fontSize:34, color:'#0e8a9c' }}>{s.value}</div>
            <div style={{ fontSize:12.5, fontWeight:600, color:'#5a726f', marginTop:4 }}>{s.label}</div>
          </div>
        ))}
      </div>
      <div style={{ height:300, borderRadius:24, overflow:'hidden' }}><div className="bgimg" style={{ backgroundImage:`url(${REGIONS[0].img})` }}></div></div>
    </div>
  );
}
